import template from "./template.twig";
import "./style.scss";

const { Component } = Shopware;

Component.register("biloba-google-gtag-introduction", {
  template,

  computed: {
    isGerman() {
      const session = Shopware.State.get("session");
      if (!session || !session.currentLocale) {
        return true;
      }
      return session.currentLocale.startsWith("de-");
    },
  },

  mounted() {
    const cardWrapper = this.$el.closest(".sw-card") || this.$el.closest(".mt-card");
    if (cardWrapper) {
      cardWrapper.style.boxShadow = "none";
      cardWrapper.style.border = "none";
      cardWrapper.style.background = "transparent";
      cardWrapper.style.padding = "0";

      const cardContent =
        cardWrapper.querySelector(".sw-card__content") ||
        cardWrapper.querySelector(".mt-card__content");
      if (cardContent) {
        cardContent.style.padding = "0";
      }
    }
  },
});
